var swiper = new Swiper(".mySwiper", {
  loop: true,
  spaceBetween: 4,
  slidesPerView: 8,
  freeMode: true,
  watchSlidesProgress: true,

  breakpoints: {
    768: {
      direction: "vertical",
      spaceBetween: 6,
    },
  },
});
var swiper2 = new Swiper(".mySwiper2", {
  loop: true,
  spaceBetween: 10,

  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },

  thumbs: {
    swiper: swiper,
  },
});
